export default __webpack_public_path__ + "static/media/marker_cluster.aa8edf5b.svg";